<section class="contact-page" aria-label="Contacto IBRO">
  <div class="contact-content">
    <header class="contact-header">
      <img class="contact-logo" src="assets/imgs/logo.png" alt="IBRO Food Safety">
      <h1>Cont&aacute;ctanos</h1>
      <span class="title-rule" aria-hidden="true"></span>
      <p>Estamos aqu&iacute; para ayudarte.<br>Escr&iacute;benos o vis&iacute;tanos en nuestras oficinas.</p>
    </header>

    <div class="countries" aria-label="Datos de contacto por pa&iacute;s">
      <article class="country">
        <h2>Chile</h2>
        <address>
          <div class="contact-row">
            <span class="contact-icon contact-icon-location" aria-hidden="true">
              <mat-icon>place</mat-icon>
            </span>
            <strong>San P&iacute;o X 2460, oficina 706,<br>Providencia, Regi&oacute;n<br>Metropolitana</strong>
          </div>
          <a class="contact-row" href="mailto:contacto@ibro-cvm.com">
            <span class="contact-icon contact-icon-mail" aria-hidden="true">
              <mat-icon>mail</mat-icon>
            </span>
            <span>contacto@ibro-cvm.com</span>
          </a>
          <a class="contact-row" href="tel:+56227372332">
            <span class="contact-icon contact-icon-phone" aria-hidden="true">
              <mat-icon>phone</mat-icon>
            </span>
            <span>+56 227 327 332</span>
          </a>
        </address>
      </article>

      <article class="country">
        <h2>Per&uacute;</h2>
        <address>
          <div class="contact-row">
            <span class="contact-icon contact-icon-location" aria-hidden="true">
              <mat-icon>place</mat-icon>
            </span>
            <strong>Oficina Lima para<br>Latinoam&eacute;rica.</strong>
          </div>
          <a class="contact-row" href="mailto:contacto@ibro-cvm.com">
            <span class="contact-icon contact-icon-mail" aria-hidden="true">
              <mat-icon>mail</mat-icon>
            </span>
            <span>contacto@ibro-cvm.com</span>
          </a>
          <a class="contact-row" href="tel:+51999123016">
            <span class="contact-icon contact-icon-phone" aria-hidden="true">
              <mat-icon>phone</mat-icon>
            </span>
            <span>+51 999123016</span>
          </a>
        </address>
      </article>
    </div>

    <nav class="social-block" aria-label="Redes sociales">
      <h2>S&iacute;guenos</h2>
      <div class="social-links">
        <a href="https://www.facebook.com/IBROFoodsafety" target="_blank" rel="noopener" aria-label="Facebook">f</a>
        <a href="https://www.instagram.com/ibrofoodsafety" target="_blank" rel="noopener" aria-label="Instagram">
          <mat-icon aria-hidden="true">photo_camera</mat-icon>
        </a>
        <a href="https://www.linkedin.com" target="_blank" rel="noopener" aria-label="LinkedIn">in</a>
      </div>
    </nav>
  </div>

  <figure class="contact-visual" aria-hidden="true">
    <img src="assets/imgs/portada.png" alt="">
  </figure>
</section>
